export enum BindableType {
  Region = 'Intergrip\\Domain\\Models\\Region',
}
